import { $api } from "../../../../../services/request.config";
import { getErrorNotificationContentAction } from "../../AuthorityRequestDelegation/getErrorNotificationContent.action";

export const editRequestDelegationThunkAction =
    (
        data,
        setIsLoading,
        setModalSuccess,
        setNotification
    ) => async (dispatch) => {
        try {
            const { id } = data;
            setIsLoading(true);
            const response = await $api.patch(`v1/manager/delegations/${id}`, data);
            if (response.status === 200) {
                setModalSuccess(true);
            }
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
            if (error.response.status === 404) {
                setNotification(true);
                dispatch(getErrorNotificationContentAction(["Делегирование не найдено."]));
            } else if (error.response.status === 409) {
                const { errors } = error.response.data;
                if (errors) {
                    const arrOfErrors = [];
                    for (const key in errors) {
                        errors[key].forEach(e => arrOfErrors.push(e));
                    }
                    dispatch(getErrorNotificationContentAction(arrOfErrors));
                    setNotification(true);
                }
            }else if (error.response.status === 422) {
                const { errors } = error.response.data;
                if (errors) {
                    const arrOfErrors = [];
                    for (const key in errors) {
                        errors[key].forEach(e => arrOfErrors.push(e));
                    }
                    dispatch(getErrorNotificationContentAction(arrOfErrors));
                    setNotification(true);
                }
            } else if (error.response.status >= 400) {
                setNotification(true);
                dispatch(getErrorNotificationContentAction(["Произошла ошибка изменения даты делегирования."]));
            } else if (error.response.status >= 500) {
                setNotification(true);
                dispatch(getErrorNotificationContentAction(["Произошла ошибка изменения даты делегирования."]));
            }
        }
    };
